import { render, staticRenderFns } from "./FrsFabOverlay.vue?vue&type=template&id=971cf180&scoped=true&lang=html&"
import script from "./FrsFabOverlay.vue?vue&type=script&lang=js&"
export * from "./FrsFabOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971cf180",
  null
  
)

export default component.exports